<template>
    <div class="container-fluid">
        <div class="card card-primary card-outline" id="newworkflow">
            <div class="card-body">
                <div class="bootbox-body">
                    <form class="change-password-form">
                        <div class="">
                            <div class="row form-group">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <span class="text-danger" id="error_msg"></span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label>Config For: <span class="text-danger">*</span></label>
                                        <select v-model="form.config_id" :class="{ 'is-invalid select2 select2-hidden-accessible': form.errors.has('config_id') }" class="form-control select2" name="config_id" id="config_id">
                                            <option value=""> --Select--</option>
                                            <option value="Admission">Online Admission For Class PP</option>
                                            <option value="Result"> Academic Result</option>
                                            <!-- <option value="private"> Enable Class XI for Private & Rigzhung</option>
                                            <option value="within_cluster"> Enable Class XI within Cluster</option>
                                            <option value="outside_cluster">Enable Class XI outside Cluster</option> -->
                                        </select>
                                        <has-error :form="form" field="config_id"></has-error>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label>Status: <span class="text-danger">*</span></label>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="status" v-model="form.status">
                                        <label class="custom-control-label" for="status">
                                            {{ form.status ? 'On' : 'Off' }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card-footer">
                <div class="row form-group fa-pull-right">
                    <div class="col-md-12">
                        <button type="button" class="btn btn-flat btn-primary" @click="SaveDetails()"> <i class="fa fa-edit"></i> Update</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return  {
            form: new form({
                config_id:'',
                status:false,
                action:'edit',
            })
        }
    },
    methods:{
        SaveDetails(){
            this.form.post('create_configuration')
            .then(() => {
                    Toast.fire({
                        icon: 'success',
                        title: 'Details Updated Successfully'
                    })
                    this.$router.push('/list_configuration');
            })
            .catch((err) => {
                console.log("Error:"+err)
            });
        },
        async changefunction(id){
            if($('#'+id).val()!=""){
                $('#'+id).removeClass('is-invalid');
                $('#'+id+'_err').html('');
                $('#'+id).addClass('select2');
            }
            if(id=="config_id"){
                this.form.config_id=$("#config_id").val();
            }
            if(id=="status"){
                this.form.status=$("#status").val();
            }
        },
        removeerror(fieldid,errid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
                $('#'+errid).html('');
            }
        },
    },

    async mounted(){
        $('.select2').select2();
        $('.select2').select2({
            theme: 'bootstrap4'
        });
        $('.select2').on('select2:select', function (el){
            Fire.$emit('changefunction',$(this).attr('id'));
        });

        Fire.$on('changefunction',(id)=> {
            this.changefunction(id);
        });
    },
        created(){
            this.form.id=this.$route.params.data.id;
            this.form.status=this.$route.params.data.status;
            this.form.config_id=this.$route.params.data.config_id;
        },
}
</script>
